// --------------------------------------------------------------
// Created On: 2021-09-21
// Author: Zachary Thomas
//
// Last Modified: 2024-12-24
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

// Generic modal body.
export default function ModalBody(props: Props): Component {
  return (
    <Modal.Body data-test="modal-body" className={props.className || undefined}>
      {props.children}
    </Modal.Body>
  );
}

ModalBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

interface Props {
  className?: string;
  children?: Children;
}
